export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA";
export const FETCH_DASHBOARD_GLOBAL_SEARCH = "FETCH_DASHBOARD_GLOBAL_SEARCH";
